import React from "react";
import styles from "./Proofing.module.css";
import ProductDetailsComponent from "../../../../../../../../components/ProductDetailsComponent/ProductDetailsComponent";
import CheckListComponent from "../../../../../../../../components/CheckListComponent/CheckListComponent";
const Proofing = () => {
  const Data = [
    { label: "Assigned To", description: "John Doe" },
    { label: "Supervisor", description: "Trever Marks" },
    { label: "Task Status", description: "Completed" },
    { label: "Flour Lot", description: "F-BATCH-2306" },
    { label: "Flour Lot", description: "F-BATCH-2306" },
    { label: "Submitted Data" },
    { label: "Water Temperature", description: "Room Temperature (70–77° F)" },
    { label: "Mixing Time", description: "8 - 10 minutes" },
    { label: "Dough Temperature (Post-Mix)", description: "75–78° F" },
    { label: "Hydration Adjustment", description: "None" },
    { label: "Flagged Issue", description: "None" },
    { label: "Machine Used", description: "Baking oven" },
    { label: "Machine Operator", description: "Stephanie Sharkey" },
  ];

  const Options = [
    { title: "Retarder sanitized prior to use" },
    { title: "Temperature/humidity checked before placing product" },
    { title: "Trays covered to prevent skin formation" },
    { title: "Product properly labeled with date/time" },

  ];

  return (
    <div className={styles.MainCont}>
      <div className={styles.LeftCont}>
        <ProductDetailsComponent Data={Data} />
      </div>
      <div className={styles.RightCont}>
        <CheckListComponent Options={Options} Heading={"Checklist"} />
      </div>
    </div>
  );
};

export default Proofing;
